package nl.astraeus.wiki.domain

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import nl.astraeus.wiki.encoding.Tokenizable
import nl.astraeus.wiki.encoding.Tokenizer

class Wiki(
  var id: Long = 0,
  var wikiId: String,
  var title: String = "Simple wiki",
  val pages: MutableList<Page> = mutableListOf(),
) {
  var lastModified: Instant = Clock.System.now()
  var currentPage: Page? = pages.firstOrNull()

  fun addPage() {
    val pageId = pages.size + 1L

    pages.add(Page(pageId, id, null, "New page", ""))
  }
}

data class WikiListDto(
  val id: Long,
  val wikiId: String,
  val userId: Long,
  var title: String,
  val pages: Int,
  val lastModified: String,
) : Tokenizable {

  constructor(token: Tokenizer) : this(
    token.next().toLong(),
    token.next(),
    token.next().toLong(),
    token.next(),
    token.next().toInt(),
    token.next(),
  )

  override fun tokenize(): String = Tokenizer.tokenize(
    id.toString(),
    wikiId,
    userId.toString(),
    title,
    pages.toString(),
    lastModified,
  )
}
